import {createSlice} from "@reduxjs/toolkit";

const initialState = {
  screenWidth: null,
}

export const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setScreenWidth: (state, action) => {
      state.screenWidth = action.payload.screenWidth
    },
  }
})

export const {setScreenWidth} = appSlice.actions

export default appSlice.reducer